import { config } from "config/config";
import { IMailbox } from "store/entities/mailboxes/interfaces";

export const prepareMailboxAddress: (licenseId: number, name?: string) => string = (licenseId, name) =>
  `${licenseId}${name ? `-${name}` : ""}@${config.defaultMailboxSuffix}`;

export const mailboxExists = (mailboxes: IMailbox[], mailboxId: string): boolean =>
  mailboxes.some(mailbox => mailbox.id === mailboxId);
